<template>
  <div class="publishing-tools">
    <NavBar></NavBar>
    <main
      property="mainContentOfPage"
      class="container"
      typeof="WebPageElement"
    >
      <Breadcrumb></Breadcrumb>
      <section class="custom-section">
        <div class="columns">
          <div class="column is-7">
            <p class="title is-2">{{ $t("publishing_tools.title") }}</p>
            <p class="large-text">
              {{ $t("publishing_tools.text_1") }}
            </p>
          </div>
          <div class="column is-5">
            <StatusBox />
          </div>
        </div>
      </section>
      <section class="custom-section">
        <div class="columns">
          <div class="column is-12">
            <p class="subtitle is-3">{{ $t("publishing_tools.subtitle_1") }}</p>
            <p>
              {{ $t("publishing_tools.text_2") }}
            </p>
          </div>
        </div>

        <div class="columns">
          <div class="column is-12">
            <p class="subtitle is-3">{{ $t("publishing_tools.subtitle_2") }}</p>
            <p>
              {{ $t("publishing_tools.text_3") }}
            </p>
          </div>
        </div>
      </section>
    </main>
    <BaseFooter></BaseFooter>
  </div>
</template>

<script>
import StatusBox from "@/components/StatusBox.vue";
import NavBar from "@/components/NavBar.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import BaseFooter from "@/components/Footer.vue";

export default {
  name: "publishing-tools",
  components: {
    StatusBox,
    NavBar,
    Breadcrumb,
    BaseFooter
  },
  created() {
    document.title = this.$t("publishing_tools.title");
  },
  updated() {
    document.title = this.$t("publishing_tools.title");
  }
};
</script>
